import $ from "jquery";
import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

function initTeaserslider($bl) {
    const swiper = new Swiper($bl.find(".swiper").get(0), {
        //loop: true,
        //rewind: true,
        autoHeight: true,
        
        slidesPerView: "auto",
        spaceBetween: 0, //controlled with margin-left on .swiper-slide

        /*
        speed: 1500,
        autoplay: {
            delay: 4000
        }
        */

        navigation: {
            prevEl: $bl.find(".icon-circlearrowleft").get(0),
            nextEl: $bl.find(".icon-circlearrowright").get(0)
        },
    });
}

$(function() {
    $(".bl-teaserslider").each(function() {
        initTeaserslider($(this));
    });
});

